var map = {
	"./amaze.png": 38971,
	"./angel.png": 74874,
	"./angry.png": 35602,
	"./applause.png": 98358,
	"./arrogant.png": 99714,
	"./astonished.png": 60823,
	"./awkward.png": 20452,
	"./bigcry.png": 85408,
	"./blessing.png": 55372,
	"./boo.png": 84392,
	"./bye.png": 63908,
	"./candle.png": 57168,
	"./cheer.png": 48840,
	"./comic.png": 18172,
	"./cool.png": 1225,
	"./crazy.png": 28626,
	"./cry.png": 8783,
	"./cute.png": 8103,
	"./daze.png": 93008,
	"./dignose.png": 71371,
	"./dizzy.png": 60591,
	"./dog.png": 31242,
	"./dontbicker.png": 87209,
	"./doubt.png": 33091,
	"./drinktea.png": 9465,
	"./dung.png": 43290,
	"./embrace.png": 87672,
	"./evil.png": 22130,
	"./facepalmcry.png": 31034,
	"./fallill.png": 17186,
	"./follow.png": 34640,
	"./frown.png": 85817,
	"./handshake.png": 62586,
	"./hard.png": 9916,
	"./heart.png": 81894,
	"./hehe.png": 71195,
	"./kiss.png": 33598,
	"./kneel.png": 66883,
	"./kneelcry.png": 33928,
	"./laughcry.png": 97581,
	"./lechery.png": 72554,
	"./letgo.png": 51155,
	"./like.png": 74033,
	"./majestic.png": 66337,
	"./ok.png": 17423,
	"./pathetic.png": 81211,
	"./praise.png": 20698,
	"./reversesmile.png": 37302,
	"./rose.png": 29067,
	"./shutup.png": 1048,
	"./shy.png": 38028,
	"./simper.png": 85196,
	"./slap.png": 69002,
	"./sleep.png": 85063,
	"./sleepy.png": 28055,
	"./smile.png": 3026,
	"./snap.png": 66094,
	"./split.png": 78048,
	"./stoptalking.png": 3302,
	"./struggle.png": 59869,
	"./sweat.png": 8611,
	"./teethlaugh.png": 80877,
	"./titter.png": 58124,
	"./vomit.png": 41539,
	"./wane.png": 55706,
	"./watermelon.png": 36620
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17587;